import { render, staticRenderFns } from "./createCourseFromDemo.vue?vue&type=template&id=5455f986&scoped=true"
import script from "./createCourseFromDemo.vue?vue&type=script&lang=ts"
export * from "./createCourseFromDemo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5455f986",
  null
  
)

export default component.exports